import React from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";
import { useTranslation } from "../../i18n";

export default function AboutThumbnailComponents() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);
  const { t } = useTranslation();

  return (
    <div className="about_content_thumbnail">
      {isMobile ? (
        // Mobile View
        <>
          <div>
            <h2 className="font-vietnam-600 font-size-36 text-uppercase lh-1">
              {t.about.headline.join(" ")}
            </h2>
            <h2 className="font-vietnam-200-italic mt-2">{t.about.name}</h2>
          </div>
        </>
      ) : (
        // Desktop View
        <>
          <div className="describe">
            <h1 className="font-vietnam-600">
              {t.about.headline.map((line) => (
                <React.Fragment key={line}>
                  {line} <br />
                </React.Fragment>
              ))}
            </h1>
            <h2 className="font-vietnam-200-italic">{t.about.name}</h2>
          </div>
          <div className="picture">
            <img
              src={require("../../assets/images/profile/profile_1.jpg")}
              alt={t.about.pictureAlt}
              width={"100%"}
              loading="lazy"
            />
          </div>
        </>
      )}
    </div>
  );
}
